import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/ServicePage";
import { SERVICES } from "@/data/services";
import { buildServiceSchemas } from "@/lib/seo";

const SLUG = "motorkerekpar-szerviz-eger" as const;
const content = SERVICES.find((service) => service.slug === SLUG);
const url = `https://lakroszautoszerviz.com/${SLUG}`;

export const Route = createFileRoute("/motorkerekpar-szerviz-eger")({
  head: () => ({
    meta: [
      { title: content?.metaTitle ?? "Motorkerékpár szerviz Eger | LAKROSZ" },
      { name: "description", content: content?.metaDescription ?? "Motorkerékpár szerviz Egerben versenypályás tapasztalattal." },
      { property: "og:title", content: content?.metaTitle ?? "Motorkerékpár szerviz Eger | LAKROSZ" },
      { property: "og:description", content: content?.metaDescription ?? "Motorkerékpár szerviz Egerben versenypályás tapasztalattal." },
      { property: "og:url", content: url },
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: "LAKROSZ Autószerviz" },
      { property: "og:locale", content: "hu_HU" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: content?.metaTitle ?? "Motorkerékpár szerviz Eger | LAKROSZ" },
      { name: "twitter:description", content: content?.metaDescription ?? "Motorkerékpár szerviz Egerben versenypályás tapasztalattal." },
    ],
    links: [{ rel: "canonical", href: url }],
    scripts: content ? buildServiceSchemas(content, url) : [],
  }),
  component: MotorkerekparPage,
});

function MotorkerekparPage() {
  if (!content) return null;
  return <ServicePage content={content} />;
}